import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { ProtectedRoutes } from './Routes/ProtectedRoutes';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import AddMember from './Pages/Member/AddMember';
import Claims from './Pages/Claims';
import Documents from './Pages/Documents';
import Notifications from './Pages/Notifications';
import HelpDesk from './Pages/HelpDesk';
import Reports from './Pages/Reports';
import Settings from './Pages/Settings';
import MainLayout from './Components/Layouts/MainLayout';
import Loader from './Pages/Loader';
import DocumentView from './Pages/DocumentView';
import { ConfirmProvider } from 'material-ui-confirm';
import { ThemeProvider } from '@emotion/react';
import { lightTheme } from './Theme/theme';
import "react-toastify/dist/ReactToastify.css";
import DocumentsViewStatus from './Pages/DocumentStatusWise';
import TransactionHistory from './Pages/TransactionHistory';
import MemberSearch from './Pages/MemberSearch';
import AllTransaction from './Pages/AllTransaction';
import ViewMember from './Pages/ViewMember';
import PaymentRequest from './Pages/PaymentRequest';
import Website from './Pages/Website';

function App() {
  return (
    <BrowserRouter>
      <Loader />
      <ToastContainer />
      <ThemeProvider theme={lightTheme}>
        <ConfirmProvider
          defaultOptions={{
            confirmationButtonProps: {
              variant: "contained",
            },
            cancellationButtonProps: {
              variant: "outlined",
            },
          }}
        >
          <MainLayout>
            <Routes>
              <Route exact path="/login" element={<Login />} />
              <Route element={<ProtectedRoutes />}>
                <Route exact path="/" element={<Dashboard />} />
                <Route exact path="/addMember" element={<AddMember />} />
                <Route exact path="/claims" element={<Claims />} />
                <Route exact path="/documents" element={<Documents />} />
                <Route exact path="/documents-view-status" element={<DocumentsViewStatus />} />
                <Route exact path="/documents-view" element={<DocumentView />} />
                <Route exact path="/notifications" element={<Notifications />} />
                <Route exact path="/helpDesk" element={<HelpDesk />} />
                <Route exact path="/reports" element={<Reports />} />
                <Route exact path="/transactionHistory" element={<TransactionHistory />} />
                <Route exact path="/settings" element={<Settings />} />
                <Route exact path="/memberSearch" element={<MemberSearch />} />
                <Route exact path="/allTransactions" element={<AllTransaction />} />
                <Route exact path="/view-member" element={<ViewMember />} />
                <Route exact path="/payment-request" element={<PaymentRequest />} />
                <Route exact path="/website" element={<Website />} />
              </Route>
            </Routes>
          </MainLayout>
        </ConfirmProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;

